export const EXCMCUSTOMFIELD_CREATE_RESET = 'EXCMCUSTOMFIELD_CREATE_RESET'
export const EXCMCUSTOMFIELD_CREATE_SET_CREATED = 'EXCMCUSTOMFIELD_CREATE_SET_CREATED'
export const EXCMCUSTOMFIELD_CREATE_SET_ERROR = 'EXCMCUSTOMFIELD_CREATE_SET_ERROR'
export const EXCMCUSTOMFIELD_CREATE_SET_VIOLATIONS = 'EXCMCUSTOMFIELD_CREATE_SET_VIOLATIONS'
export const EXCMCUSTOMFIELD_CREATE_TOGGLE_LOADING = 'EXCMCUSTOMFIELD_CREATE_TOGGLE_LOADING'
